/**
 * Кастомная иконка «Подарок» — filled коробка с бантом из Streamline Plump
 *
 * fill="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function GiftIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3338 7.78007V13.5566H2C2.01734 11.6564 2.10625 10.2456 2.20139 9.25842C2.32721 7.95253 3.28437 6.96444 4.52873 6.73598C4.32501 6.29657 4.21985 5.81795 4.22064 5.33363C4.22064 3.50636 5.61704 2 7.55494 2C9.16162 2 10.4442 2.93475 11.2929 3.96506C11.5672 4.29843 11.8042 4.65046 12.0007 5.00071C12.1967 4.65046 12.4341 4.29843 12.7084 3.96506C13.5576 2.93475 14.8397 2 16.4464 2C18.3843 2 19.7807 3.50636 19.7807 5.33363C19.7814 5.81798 19.6761 6.29661 19.4722 6.73598C20.7161 6.96444 21.6728 7.95297 21.7986 9.25798C21.8937 10.2456 21.9831 11.6564 22 13.5566H12.6675V7.78007C12.223 7.77771 11.7784 7.77771 11.3338 7.78007ZM5.55436 5.33363C5.55436 4.21531 6.38082 3.33345 7.55494 3.33345C8.61569 3.33345 9.55596 3.9544 10.2633 4.81314C10.5906 5.20998 10.8619 5.64982 11.0697 6.12037C11.1165 6.22766 11.1589 6.3368 11.1969 6.44751C9.00825 6.46084 7.29575 6.53018 6.01494 6.61019C5.71655 6.25177 5.55354 5.79996 5.55436 5.33363ZM17.9864 6.61019C16.706 6.53018 14.9931 6.46129 12.8045 6.44751C12.8396 6.34527 12.8818 6.23593 12.9316 6.12037C13.1394 5.64982 13.4107 5.20998 13.7381 4.81314C14.4449 3.9544 15.3856 3.33345 16.4464 3.33345C17.6205 3.33345 18.447 4.21531 18.447 5.33363C18.4478 5.79996 18.2848 6.25177 17.9864 6.61019Z"
        fill="currentColor"
      />
      <path
        d="M11.3339 14.89V22C8.30498 21.9844 6.1728 21.8626 4.82397 21.7497C3.43868 21.6342 2.33747 20.5954 2.20188 19.1886C2.10674 18.201 2.01783 16.7902 2.00049 14.89H11.3339Z"
        fill="currentColor"
      />
      <path
        d="M12.6675 14.89V22C15.6959 21.9844 17.8276 21.8626 19.1765 21.7497C20.5618 21.6342 21.6634 20.5954 21.7986 19.1886C21.8937 18.201 21.9831 16.7902 22 14.89H12.6675Z"
        fill="currentColor"
      />
    </svg>
  );
}